// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
// ##### 25-04-11 Komarov
import { useDispatch, useSelector } from 'react-redux';
// ##### 23-03-29 Komarov
import { Link } from 'react-router-dom';
import { localizePath } from '../../Pages/Helpers/localizeRoutePath';
// ##### 25-05-21 Komarov
import IconHint from '../Icons/iconHint';
// ##### 25-04-23 Komarov
import { getLoadedPage } from '../../../Redux/actions';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const LocalizationNavLink = ({
  to,
  onClick,
  children,
  hintIsPresent = false,
  hintText = '',
}) => {
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  // ##### 24-08-07 Komarov
  const handleOnClick = () => {
    if (typeof onClick === 'function') onClick();
  };

  // ##### 23-08-29 Komarov
  const [isHintShown, setIsHintShown] = useState(false);
  const [y, setY] = useState(undefined);
  const [x, setX] = useState(undefined);

  const onMouseEnter = e => {
    setIsHintShown(true);
    setY(e.clientY - 50);
    setX(e.clientX);
    // ##### 25-04-11 Komarov
    setHovered(true);
    e.stopPropagation();
  };

  const onMouseLeave = () => {
    setIsHintShown(false);
    setY(undefined);
    setX(undefined);
    // ##### 25-04-11 Komarov
    setHovered(false);
  };

  // ##### 25-04-11 Komarov
  const [hovered, setHovered] = useState(false);
  const dispatch = useDispatch();
  // ##### 25-04-23 Komarov
  const loadedpages_loaded = useSelector(
    state => state.pages.loadedpages_loaded
  );
  // ##### 25-04-03 Komarov
  // const preloadedcitiespages_loaded = useSelector((state) => state.pages.preloadedcitiespages_loaded);

  const deviceType = useSelector(state => state.deviceType);
  // ##### 25-04-01 Komarov
  // const { user: currentUser } = useSelector((state) => state.auth);
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery(to);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (
      to &&
      !to.includes('search_results_hotels') &&
      hovered &&
      // ##### Komarov 2025-07-28
      !loadedpages_loaded[search_data.id]?.[locale]
    ) {
      // ##### 25-04-01 Komarov
      /*if (to.includes("city_overview") && !preloadedcitiespages_loaded[search_data.id]) {
        dispatch(getPreloadedCityPage(search_data.id, deviceType, locale, currentUser.user_id));
      } else {
        dispatch(getPreloadedPage(search_data.id, deviceType, locale));
      }*/
      // ##### 25-04-23 Komarov
      if (to.includes('sitepages')) {
        dispatch(
          getLoadedPage({ spid: search_data.spid, lang: locale, deviceType })
        );
      }
    }
  }, [hovered]);

  return (
    <>
      <Link
        to={localizePath(to, locale)}
        // ##### 24-08-07 Komarov
        onClick={handleOnClick}
        // ##### 25-05-12 Komarov
        // onMouseEnter={onMouseEnter}
        onMouseEnter={(hintIsPresent && onMouseEnter) || undefined}
        onMouseLeave={(hintIsPresent && onMouseLeave) || undefined}
      >
        {children}
      </Link>
      {/* ##### 23-08-29 Komarov */}
      {hintText !== '' && (
        <span
          style={
            (x && { position: 'absolute', left: x }) || { position: 'absolute' }
          }
        >
          <IconHint isHintShown={isHintShown} hintText={hintText} y={y} />
        </span>
      )}
    </>
  );
};

// ##### 25-05-21 Komarov
export default LocalizationNavLink;
